/* Herbal Talents – Rabattcode-Feld im Warenkorb (Drawer + Warenkorbseite) */
(function () {
  if (window.__htDisc) return;
  window.__htDisc = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MSG_KEY = 'ht-disc-msg';
  var OPEN_KEY = 'ht-disc-open-drawer';
  var codes = [];
  var itemCount = 0;

  var css =
    '.ht-disc{margin:0 0 14px;text-align:left}' +
    '.ht-disc__label{display:block;font-size:14px;font-weight:600;margin:0 0 6px}' +
    '.ht-disc__row{display:flex;gap:8px}' +
    '.ht-disc__input{flex:1;min-width:0;height:44px;padding:0 12px;border:1px solid #d1d1d1;border-radius:12px;font:inherit;font-size:15px;text-transform:uppercase;background:#fff;color:#1d1d1d}' +
    '.ht-disc__input:focus{outline:2px solid #839c8a;outline-offset:1px}' +
    '.ht-disc__btn{height:44px;padding:0 18px;border:0;border-radius:12px;background:#1d1d1d;color:#fff;font:inherit;font-size:15px;cursor:pointer;white-space:nowrap}' +
    '.ht-disc__btn[aria-busy="true"]{opacity:.6;pointer-events:none}' +
    '.ht-disc__msg{margin:6px 0 0;font-size:13px;color:#b3261e}' +
    '.ht-disc__msg:empty{display:none}' +
    '.ht-disc__msg.is-ok{color:#2e7d32}' +
    '.ht-disc__codes{list-style:none;padding:0;margin:8px 0 0;display:flex;flex-wrap:wrap;gap:6px}' +
    '.ht-disc__code{display:inline-flex;align-items:center;gap:8px;padding:4px 12px;border-radius:999px;background:#ededef;font-size:13px;font-weight:600}' +
    '.ht-disc__remove{border:0;background:none;cursor:pointer;font-size:18px;line-height:1;padding:0;color:#1d1d1d}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function boxHtml(id) {
    var list = '';
    if (codes.length) {
      list = '<ul class="ht-disc__codes">' + codes.map(function (c) {
        return '<li class="ht-disc__code">' + esc(c) +
          '<button type="button" class="ht-disc__remove" data-ht-disc-remove="' + esc(c) + '" aria-label="Code ' + esc(c) + ' entfernen">&times;</button></li>';
      }).join('') + '</ul>';
    }
    return '<label class="ht-disc__label" for="HtDisc-' + id + '">Rabattcode</label>' +
      '<div class="ht-disc__row">' +
      '<input class="ht-disc__input" id="HtDisc-' + id + '" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Code eingeben" data-ht-disc-input>' +
      '<button type="button" class="ht-disc__btn" data-ht-disc-apply>Einl&ouml;sen</button>' +
      '</div><p class="ht-disc__msg" role="status" data-ht-disc-msg></p>' + list;
  }

  function targets() {
    var t = [];
    var drawer = document.querySelector('#CartDrawer .drawer-footer');
    if (drawer) t.push({ el: drawer, id: 'drawer', before: drawer.querySelector('.cart-drawer-footer') });
    var page = document.querySelector('#main-cart-footer .cart__blocks .js-contents');
    if (page) t.push({ el: page.parentNode, id: 'page', before: page });
    return t;
  }

  function inject() {
    if (itemCount < 1) {
      document.querySelectorAll('[data-ht-disc]').forEach(function (b) { b.remove(); });
      return;
    }
    targets().forEach(function (t) {
      var box = t.el.querySelector('[data-ht-disc]');
      var key = codes.join(',');
      if (box && box.getAttribute('data-codes') === key) return;
      if (!box) {
        box = document.createElement('div');
        box.className = 'ht-disc';
        box.setAttribute('data-ht-disc', '');
        if (t.before && t.before.parentNode === t.el) t.el.insertBefore(box, t.before);
        else t.el.insertBefore(box, t.el.firstChild);
      }
      var keepMsg = box.querySelector('[data-ht-disc-msg]');
      var msgText = keepMsg ? keepMsg.textContent : '';
      var msgOk = keepMsg ? keepMsg.classList.contains('is-ok') : false;
      box.setAttribute('data-codes', key);
      box.innerHTML = boxHtml(t.id);
      if (msgText) setMsg(msgText, msgOk);
    });
  }

  function readCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        itemCount = cart.item_count || 0;
        codes = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable !== false; })
          .map(function (d) { return String(d.code).toUpperCase(); });
        return cart;
      });
  }

  function updateCart(list) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  function isApplied(cart, code) {
    var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code; })[0];
    return !!(hit && hit.applicable !== false);
  }

  function setMsg(text, ok) {
    document.querySelectorAll('[data-ht-disc-msg]').forEach(function (el) {
      el.textContent = text;
      el.classList.toggle('is-ok', !!ok);
    });
  }

  function reloadWith(text, ok) {
    try {
      sessionStorage.setItem(MSG_KEY, JSON.stringify({ text: text, ok: ok }));
      if (document.querySelector('#CartDrawer') && !/\/cart\/?$/.test(location.pathname)) sessionStorage.setItem(OPEN_KEY, '1');
    } catch (e) {}
    location.reload();
  }

  function apply(box) {
    var input = box.querySelector('[data-ht-disc-input]');
    var btn = box.querySelector('[data-ht-disc-apply]');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) { setMsg('Bitte gib einen Code ein.'); input.focus(); return; }
    if (codes.indexOf(code) > -1) { setMsg('Der Code ' + code + ' ist bereits eingelöst.', true); return; }
    btn.setAttribute('aria-busy', 'true');
    var before = codes.slice();
    updateCart(before.concat(code)).then(function (cart) {
      if (isApplied(cart, code)) { reloadWith('Code ' + code + ' eingelöst.', true); return; }
      return updateCart(before).then(function () {
        btn.removeAttribute('aria-busy');
        setMsg('Der Code ' + code + ' ist nicht gültig oder passt nicht zu den Artikeln im Warenkorb.');
      });
    }).catch(function () {
      btn.removeAttribute('aria-busy');
      setMsg('Das hat nicht geklappt. Bitte versuch es noch einmal.');
    });
  }

  function removeCode(code) {
    var rest = codes.filter(function (c) { return c !== code.toUpperCase(); });
    updateCart(rest).then(function () { reloadWith('Code ' + code + ' entfernt.', true); })
      .catch(function () { setMsg('Das hat nicht geklappt. Bitte versuch es noch einmal.'); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ht-disc-apply]');
    var r = e.target.closest && e.target.closest('[data-ht-disc-remove]');
    if (a) { e.preventDefault(); apply(a.closest('[data-ht-disc]')); }
    if (r) { e.preventDefault(); removeCode(r.getAttribute('data-ht-disc-remove')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ht-disc-input]')) {
      e.preventDefault();
      apply(e.target.closest('[data-ht-disc]'));
    }
  });

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { readCart().then(inject).catch(function () {}); }, 250);
  }

  function start() {
    readCart().then(function () {
      inject();
      try {
        var s = JSON.parse(sessionStorage.getItem(MSG_KEY) || 'null');
        if (s) { setMsg(s.text, s.ok); sessionStorage.removeItem(MSG_KEY); }
        if (sessionStorage.getItem(OPEN_KEY)) {
          sessionStorage.removeItem(OPEN_KEY);
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.open === 'function') d.open();
        }
      } catch (e) {}
    }).catch(function () {});
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n.closest && (n.closest('#CartDrawer') || n.closest('#main-cart-footer') || n.closest('#main-cart-items'))) {
          if (n.closest('[data-ht-disc]')) continue;
          schedule();
          return;
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();